<template>
  <v-row no-gutters>
    <v-col class="pa-2" cols="12">
      <div class="pa-4 my-5">
        <v-alert border="left" class="red--text" color="grey lighten-2">
          <v-icon class="me-2" color="red">mdi-information</v-icon>
          {{ $t("buyPanel.alert.choosePanel") }}
        </v-alert>

        <swiper-slider>
          <div
            v-for="(item, i) in packs"
            :key="i"
            class="swiper-slide px-md-8 pb-8"
          >
            <panel-card :color="colors[i]" :item="item" @buy="buyPack" />
          </div>
        </swiper-slider>

        <custom-popup
          v-model="buyDialog"
          :cons="{ title: $t('buyPanel.dialog.title') }"
          hide-confirm
        >
          <v-card class="pa-5" flat>
            <v-card-title class="text-center justify-center">
              <v-img
                max-height="80"
                max-width="80"
                src="/media/svg/icons/Code/Question-circle.svg"
              />
            </v-card-title>

            <v-card-title
              class="text-center justify-center"
              style="word-break: break-word"
              v-text="
                $t('buyPanel.dialog.confirmPurchase', {
                  title: selectedPack.title,
                })
              "
            />

            <v-card-title class="justify-center">
              <v-chip color="transparent" x-large>
                {{ persian(price(selectedPack.price)) }}
              </v-chip>
              <v-icon>mdi-currency-rial</v-icon>
            </v-card-title>

            <v-card-text class="text-subtitle-1 pa-0 d-flex justify-center">
              <v-btn
                v-if="hasDiscount === false"
                class="btn-update"
                @click="hasDiscount = true"
              >
                <v-icon class="ml-2">mdi-brightness-percent</v-icon>
                {{ $t("buyPanel.dialog.iHaveDiscount") }}
              </v-btn>

              <v-row v-if="hasDiscount === true" class="mt-2">
                <v-text-field
                  v-model="discount"
                  :error-messages="errorMessages"
                  class="mr-4"
                  dense
                  filled
                  :label="$t('buyPanel.dialog.discountCodeLabel')"
                  :placeholder="$t('buyPanel.dialog.discountCodePlaceholder')"
                  rounded
                />

                <v-btn
                  :loading="loading"
                  class="ml-5"
                  color="primary"
                  rounded
                  x-large
                  @click="applyVoucher"
                >
                  {{ $t("buyPanel.dialog.applyDiscount") }}
                </v-btn>
              </v-row>
            </v-card-text>

            <v-card-actions class="justify-space-around px-0 mt-1">
              <v-btn
                :loading="loading"
                class="btn-accept"
                elevation="0"
                width="80%"
                x-large
                @click="mainbuyPack"
              >
                <v-icon class="ml-2">mdi-basket</v-icon>
                {{ $t("buyPanel.dialog.purchase") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </custom-popup>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Wallet from "./wallet";
import router from "@/router";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SwiperSlider from "@/view/content/cm/swiperSlider";
import PanelCard from "@/view/content/fragment/panelCard";

export default {
  name: "buyPanel",
  components: {
    PanelCard,
    SwiperSlider,
    Wallet,
  },

  data: () => ({
    buyDialog: false,
    hasDiscount: false,
    discount: null,
    show: false,
    errorMessages: [],
    loading: false,
    colors: [
      ["#68F9C8", "#1F68F5"],
      ["#68F9C8", "#1F68F5"],
      ["#68F9C8", "#1F68F5"],
      ["#68F9C8", "#1F68F5"],
      ["#68F9C8", "#1F68F5"],
      ["#68F9C8", "#1F68F5"],
    ],
    selectedPack: {
      title: "",
      id: "",
      price: 0,
    },
    dialog: {},
    packs: [],
    openDialog: null,
  }),

  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }
      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }
      if (this.$vuetify.breakpoint.md) {
        return 2;
      }
      return 1;
    },
  },

  mounted() {
    this.getPacks();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("buyPanel.title"), route: this.$route.path },
    ]);
  },

  watch: {
    discount(val) {
      if (val.length === 0) {
        this.errorMessages = null;
      }
    },
  },

  methods: {
    getPacks() {
      this.$modal.showLoading();
      this.requestApiGet("fronttPack").then(({ data }) => {
        this.packs = data.data;
        this.$modal.hideLoading();
      });
    },

    goToCore() {
      router.push({ name: "home" });
    },

    applyVoucher() {
      this.loading = true;
      this.requestApiPost("applyVoucher", {
        pack_id: this.selectedPack.id,
        discount_code: this.discount,
      })
        .then((response) => {
          this.loading = false;
          this.$toast.success(this.$t("buyPanel.toast.discountApplied"));
          this.selectedPack.price = response.data.price;
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessages = error.response.data.discount;
          this.$toast.error(
            this.$t("buyPanel.toast.error", {
              message: error.response.data.message,
            })
          );
        });
    },

    buyPack(id) {
      this.selectedPack.id = id.id;
      this.selectedPack.title = id.title;
      this.selectedPack.price = id.price;
      this.buyDialog = true;
    },

    mainbuyPack() {
      if (this.discount) {
        this.loading = true;
        this.requestApiPost(`buyPack/${this.selectedPack.id}`, {
          discount_code: this.discount,
        })
          .then(({ data }) => {
            this.$toast.success(this.$t("buyPanel.toast.purchaseSuccess"));
            this.loading = false;
            this.getPacks();
            location.reload();
          })
          .catch(({ response }) => {
            this.$toast.error(
              this.$t("buyPanel.toast.error", {
                message: response.data.message,
              })
            );
            if (response.data != null && response.data.discount != null) {
              this.$toast.error(
                this.$t("buyPanel.toast.validationError", {
                  message: response.data.discount,
                })
              );
            }
            if (response.status === 401) {
              this.$toast.error(this.$t("buyPanel.toast.unauthorized"));
              this.$router.push({ name: "increaseTransactions" });
            }
            if (response.status === 422) {
              this.errorMessages = response.data.discount;
              this.$toast.error(
                this.$t("buyPanel.toast.validationError", {
                  message: response.data.message,
                })
              );
            }
          })
          .finally(() => (this.loading = false));
      } else {
        this.loading = true;
        this.requestApiPost(`buyPack/${this.selectedPack.id}`)
          .then(({ data }) => {
            this.loading = false;
            this.$toast.success(this.$t("buyPanel.toast.purchaseSuccess"));
            this.getPacks();
            location.reload();
          })
          .catch(({ response }) => {
            this.$toast.error(
              this.$t("buyPanel.toast.error", {
                message: response.data.message,
              })
            );
            if (response.status === 401) {
              this.$toast.error(this.$t("buyPanel.toast.unauthorized"));
              this.$router.push({ name: "increaseTransactions" });
            }
            if (response.status === 422) {
              this.$toast.error(
                this.$t("buyPanel.toast.validationError", {
                  message: response.data.message,
                })
              );
            }
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>

<style lang="css" scoped>
.shadows {
  box-shadow: 5px 5px 5px 5px blanchedalmond;
}

.text-subtitle-1,
.text-caption {
  font-family: vazir, Roboto, sans-serif !important;
}

.buy {
  background-color: #b958ff !important;
  box-shadow: 3px 4px 6px #b958ff;
  color: white !important;
}

.buy:hover {
  background-color: #b958ff !important;
  box-shadow: none !important;
  color: white !important;
}

.options {
  border: 1px solid #6da5ff !important;
  box-shadow: 2px 3px 4px #6da5ff;
  background-color: white !important;
  color: #6da5ff !important;
}

.options:hover {
  background-color: #6da5ff !important;
  box-shadow: none !important;
  color: white !important;
}
</style>
